import React from "react";
import { Link, NavLink } from "react-router-dom";
import "../App.css";
import logoEniato from '../assets/teste.png'

const NAV_LINKS = [
  { label: "Início", to: "/", end: true },
  { label: "Serviços", to: "/servicos" },
  { label: "Sobre", to: "/sobre" },
  { label: "Contato", to: "/contato" },
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__logo" aria-label="Eniato Contabilidade - página inicial">
          <img src={logoEniato} alt="Eniato Contabilidade" className="header__logo-img" />
        </Link>

        <button
          type="button"
          className={"header__toggle" + (isMenuOpen ? " header__toggle--open" : "")}
          aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
          aria-expanded={isMenuOpen}
          aria-controls="header-nav"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span className="header__toggle-bar" />
          <span className="header__toggle-bar" />
          <span className="header__toggle-bar" />
        </button>

        <nav
          id="header-nav"
          className={"header__nav" + (isMenuOpen ? " header__nav--open" : "")}
          aria-label="Navegação principal"
        >
          <ul className="header__nav-list">
            {NAV_LINKS.map((link) => (
              <li key={link.label} className="header__nav-item">
                <NavLink
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    "header__nav-link" + (isActive ? " header__nav-link--active" : "")
                  }
                  onClick={closeMenu}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
